import { ComponentProps } from "react";
import { styled } from "~/application/theme";

export const Text = styled("span", {
  // Reset
  lineHeight: 1.3,
  margin: "0",
  fontFamily: "$default",
  fontVariantNumeric: "tabular-nums",

  variants: {
    size: {
      "1": {
        fontSize: "$xxs",
      },
      "2": {
        fontSize: "$xs",
      },
      "3": {
        fontSize: "$sm",
      },
      "4": {
        fontSize: "$md",
      },
      "5": {
        fontSize: "$lg",
      },
      "6": {
        fontSize: "$xl",
      },
      "7": {
        fontSize: "$2xl",
      },
      "8": {
        fontSize: "$4xl",
      },
      "9": {
        fontSize: "$5xl",
      },
    },
    media: {
      "@mxmd": {
        backgroundColor: "red",
        margin: "0 auto",
      },
    },
    variant: {
      sucess: {
        color: "$success-base",
      },
      "sucess-light": {
        color: "$success-light",
      },
      neutral: {
        color: "$neutrals-base",
      },
      primary: {
        color: "$primary-base",
      },
      "primary-dark": {
        color: "$primary-dark",
      },
      black: {
        color: "$neutrals-black",
      },
      white: {
        color: "$neutrals-white",
      },
      dark: {
        color: "$neutrals-dark",
      },
      darkest: {
        color: "$neutrals-darkest",
      },
      "error-base": {
        color: "$error-base",
      },
      "error-dark": {
        color: "$error-dark",
      },
      "error-light": {
        color: "$error-light",
      },
      "warning-base": {
        color: "$warning-base",
      },
      "warning-dark": {
        color: "$warning-dark",
      },
      "neutral-50": {
        color: "$neutral-50",
      },
      "neutral-100": {
        color: "$neutral-100",
      },
      "neutral-200": {
        color: "$neutral-200",
      },
      "neutral-300": {
        color: "$neutral-300",
      },
      "neutral-400": {
        color: "$neutral-400",
      },
      "neutral-500": {
        color: "$neutral-500",
      },
      "neutral-600": {
        color: "$neutral-600",
      },
      "neutral-700": {
        color: "$neutral-700",
      },
      "neutral-800": {
        color: "$neutral-800",
      },
      "neutral-900": {
        color: "$neutral-900",
      },
      "primary-50": {
        color: "$primary-50",
      },
      "primary-100": {
        color: "$primary-100",
      },
      "primary-200": {
        color: "$primary-200",
      },
      "primary-300": {
        color: "$primary-300",
      },
      "primary-400": {
        color: "$primary-400",
      },
      "primary-500": {
        color: "$primary-500",
      },
      "primary-600": {
        color: "$primary-600",
      },
      "primary-700": {
        color: "$primary-700",
      },
      "primary-800": {
        color: "$primary-800",
      },
      "primary-900": {
        color: "$primary-900",
      },
      "warning-50": {
        color: "$warning-50",
      },
      "warning-100": {
        color: "$warning-100",
      },
      "warning-200": {
        color: "$warning-200",
      },
      "warning-300": {
        color: "$warning-300",
      },
      "warning-400": {
        color: "$warning-400",
      },
      "warning-500": {
        color: "$warning-500",
      },
      "warning-600": {
        color: "$warning-600",
      },
      "warning-700": {
        color: "$warning-700",
      },
      "warning-800": {
        color: "$warning-800",
      },
      "warning-900": {
        color: "$warning-900",
      },
      "danger-50": {
        color: "$danger-50",
      },
      "danger-100": {
        color: "$danger-100",
      },
      "danger-200": {
        color: "$danger-200",
      },
      "danger-300": {
        color: "$danger-300",
      },
      "danger-400": {
        color: "$danger-400",
      },
      "danger-500": {
        color: "$danger-500",
      },
      "danger-600": {
        color: "$danger-600",
      },
      "danger-700": {
        color: "$danger-700",
      },
      "danger-800": {
        color: "$danger-800",
      },
      "danger-900": {
        color: "$danger-900",
      },
      "success-50": {
        color: "$success-50",
      },
      "success-100": {
        color: "$success-100",
      },
      "success-200": {
        color: "$success-200",
      },
      "success-300": {
        color: "$success-300",
      },
      "success-400": {
        color: "$success-400",
      },
      "success-500": {
        color: "$success-500",
      },
      "success-600": {
        color: "$success-600",
      },
      "success-700": {
        color: "$success-700",
      },
      "success-800": {
        color: "$success-800",
      },
      "success-900": {
        color: "$success-900",
      },
    },
    fw: {
      "100": {
        fw: 100,
      },
      "200": {
        fw: 200,
      },
      "300": {
        fw: 300,
      },
      "400": {
        fw: 400,
      },
      "500": {
        fw: 500,
      },
      "600": {
        fw: 600,
      },
      "700": {
        fw: 700,
      },
      "800": {
        fw: 800,
      },
      "900": {
        fw: 900,
      },
    },
    paragraph: {
      true: {
        display: "block",
      },
    },
    gradient: {
      true: {
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
      },
    },
  },
});

export type TextProps = ComponentProps<typeof Text>;
